import { Config } from "../../../configurations/config";

export const ResourceDailyHoursAPIs = {
	GetEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetResourceDailyHours: `${Config.server_url}${Config.api_prefix}/TimeSheet/ResourceDailyHours`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/ResourceDailyHours/ExportToExcel`,
};
